var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
      _c("h3", { staticClass: "text-themecolor" }, [
        _vm._v("Limited Partners\n                "),
        _vm.investor.name
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(_vm.investor.name) +
                  " (" +
                  _vm._s(_vm.investor.cp_email) +
                  ")"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/investors")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v(_vm._s(_vm.trans("investor.investor_list"))),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-sm-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body p-4" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("investor-sidebar", {
                      attrs: { menu: "basic", id: _vm.id },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 col-sm-9" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.trans("investor.basic"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                            keydown: function ($event) {
                              return _vm.investorForm.errors.clear(
                                $event.target.name
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12 col-sm-12" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12 col-sm-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("investor.name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.investorForm.name,
                                            expression: "investorForm.name",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          value: "",
                                          name: "name",
                                          placeholder:
                                            _vm.trans("investor.name"),
                                        },
                                        domProps: {
                                          value: _vm.investorForm.name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.investorForm,
                                              "name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("show-error", {
                                        attrs: {
                                          "form-name": _vm.investorForm,
                                          "prop-name": "name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12 col-sm-12" }, [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Active")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.investorForm.active,
                                                    expression:
                                                      "investorForm.active",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { name: "active" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.investorForm,
                                                      "active",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("Not available")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "Yes" } },
                                                  [_vm._v("Yes")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "No" } },
                                                  [_vm._v("No")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Label")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.investorForm.label,
                                                    expression:
                                                      "investorForm.label",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { name: "active" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.investorForm,
                                                      "label",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("None")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.labels,
                                                  function (label, index) {
                                                    return _c(
                                                      "option",
                                                      { key: label.name },
                                                      [
                                                        _vm._v(
                                                          "\n                                                            " +
                                                            _vm._s(label.name) +
                                                            "\n                                                          "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Website")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm.website,
                                                  expression:
                                                    "investorForm.website",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "website",
                                                placeholder:
                                                  _vm.trans(
                                                    "transcript.active"
                                                  ),
                                              },
                                              domProps: {
                                                value: _vm.investorForm.website,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "website",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("ESG Status")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.investorForm
                                                        .esg_status,
                                                    expression:
                                                      "investorForm.esg_status",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { name: "esg_status" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.investorForm,
                                                      "esg_status",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("Not available")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "Yes" } },
                                                  [_vm._v("Yes")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "No" } },
                                                  [_vm._v("No")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Open to First-Time Funds"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.investorForm
                                                        .open_to_first_time_funds,
                                                    expression:
                                                      "investorForm.open_to_first_time_funds",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  name: "open_to_first_time_funds",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.investorForm,
                                                      "open_to_first_time_funds",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("Not available")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "Yes" } },
                                                  [_vm._v("Yes")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  { attrs: { value: "No" } },
                                                  [_vm._v("No")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Holding Period")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .holding_period,
                                                  expression:
                                                    "investorForm.holding_period",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "holding_period",
                                                placeholder: _vm.trans(
                                                  "transcript.holding_period"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .holding_period,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "holding_period",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Preferred Fund Type (Asset Classes)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "preferred_fund_type_organization",
                                                id: "preferred_fund_type_organization",
                                                options:
                                                  _vm.investor_preferred_fund_types,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_preferred_fund_type_organizations,
                                              },
                                              on: {
                                                select:
                                                  _vm.onInvestorPreferredFundTypeSelect,
                                                remove:
                                                  _vm.onInvestorPreferredFundTypeRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_preferred_fund_type_organizations,
                                                callback: function ($$v) {
                                                  _vm.selected_preferred_fund_type_organizations =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_preferred_fund_type_organizations",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Preferred Geography")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "preferred_geography",
                                                id: "preferred_geography",
                                                options: _vm.countries,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_preferred_geographies,
                                              },
                                              on: {
                                                select:
                                                  _vm.onPreferredGeographySelect,
                                                remove:
                                                  _vm.onPreferredGeographyRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_preferred_geographies,
                                                callback: function ($$v) {
                                                  _vm.selected_preferred_geographies =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_preferred_geographies",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Description")]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .description,
                                                  expression:
                                                    "investorForm.description",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              staticStyle: { height: "80px" },
                                              attrs: { name: "description" },
                                              domProps: {
                                                value:
                                                  _vm.investorForm.description,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "description",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Policy Description")]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .policy_description,
                                                  expression:
                                                    "investorForm.policy_description",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              staticStyle: { height: "80px" },
                                              attrs: {
                                                name: "policy_description",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .policy_description,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "policy_description",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Limited Partner Type (Investor Type)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "limited_partner_type_organization",
                                                id: "limited_partner_type_organization",
                                                options:
                                                  _vm.limited_partner_type_organizations,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_limited_partner_type_organizations,
                                              },
                                              on: {
                                                select:
                                                  _vm.onLimitedPartnerTypeOrganizationSelect,
                                                remove:
                                                  _vm.onLimitedPartnerTypeOrganizationRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_limited_partner_type_organizations,
                                                callback: function ($$v) {
                                                  _vm.selected_limited_partner_type_organizations =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_limited_partner_type_organizations",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Investment Structure")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "investment_structure",
                                                id: "investment_structure",
                                                options:
                                                  _vm.investment_structures,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_investment_structures,
                                              },
                                              on: {
                                                select:
                                                  _vm.onInvestmentStructureSelect,
                                                remove:
                                                  _vm.onInvestmentStructureRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_investment_structures,
                                                callback: function ($$v) {
                                                  _vm.selected_investment_structures =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_investment_structures",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Preferred Commitment Size (USD MN)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .preferred_commitment_size,
                                                  expression:
                                                    "investorForm.preferred_commitment_size",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "preferred_commitment_size",
                                                placeholder: _vm.trans(
                                                  "transcript.preferred_commitment_size"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .preferred_commitment_size,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "preferred_commitment_size",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Commitments")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .commitments,
                                                  expression:
                                                    "investorForm.commitments",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "commitments",
                                                placeholder: _vm.trans(
                                                  "transcript.commitments"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm.commitments,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "commitments",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Commitments in RE Funds"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .commitments_in_re_funds,
                                                  expression:
                                                    "investorForm.commitments_in_re_funds",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "commitments_re",
                                                placeholder: _vm.trans(
                                                  "transcript.commitments_re"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .commitments_in_re_funds,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "commitments_in_re_funds",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Commitments in VC Funds"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .commitments_in_vc_funds,
                                                  expression:
                                                    "investorForm.commitments_in_vc_funds",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "commitments_vc",
                                                placeholder: _vm.trans(
                                                  "transcript.commitments_vc"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .commitments_in_vc_funds,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "commitments_in_vc_funds",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Commitments in Infrastructure"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .commitments_in_infrastructure,
                                                  expression:
                                                    "investorForm.commitments_in_infrastructure",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "commitments_inv",
                                                placeholder: _vm.trans(
                                                  "transcript.commitments_inv"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .commitments_in_infrastructure,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "commitments_in_infrastructure",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Commitments in PE Funds"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .commitments_in_pe_funds,
                                                  expression:
                                                    "investorForm.commitments_in_pe_funds",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "commitments_pe",
                                                placeholder: _vm.trans(
                                                  "transcript.commitments_pe"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .commitments_in_pe_funds,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "commitments_in_pe_funds",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Alternative Investments (%)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .alternative_investments_perc,
                                                  expression:
                                                    "investorForm.alternative_investments_perc",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "inv_alt",
                                                placeholder:
                                                  _vm.trans(
                                                    "transcript.inv_alt"
                                                  ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .alternative_investments_perc,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "alternative_investments_perc",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Real Estate (%)")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .real_estate_perc,
                                                  expression:
                                                    "investorForm.real_estate_perc",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "real_estate_perc",
                                                placeholder: _vm.trans(
                                                  "transcript.real_estate_perc"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .real_estate_perc,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "real_estate_perc",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Private Equity (%)")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .private_equity_perc,
                                                  expression:
                                                    "investorForm.private_equity_perc",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "private_equity_perc",
                                                placeholder: _vm.trans(
                                                  "transcript.private_equity_perc"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .private_equity_perc,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "private_equity_perc",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Alternative Investments (USD MN)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .alternative_investments_amn,
                                                  expression:
                                                    "investorForm.alternative_investments_amn",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "alternative_investments",
                                                placeholder: _vm.trans(
                                                  "transcript.alternative_investments"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .alternative_investments_amn,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "alternative_investments_amn",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Real Estate (USD MN)")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .real_estate_amn,
                                                  expression:
                                                    "investorForm.real_estate_amn",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "real_estate_amount",
                                                placeholder: _vm.trans(
                                                  "transcript.real_estate_amount"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .real_estate_amn,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "real_estate_amn",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Private Equity (USD MN)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .private_equity_amn,
                                                  expression:
                                                    "investorForm.private_equity_amn",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "private_equity_amount",
                                                placeholder: _vm.trans(
                                                  "transcript.private_equity_amount"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .private_equity_amn,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "private_equity_amn",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Number of employees")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .number_of_employees,
                                                  expression:
                                                    "investorForm.number_of_employees",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "number_of_employees",
                                                placeholder: _vm.trans(
                                                  "transcript.number_of_employees"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .number_of_employees,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "number_of_employees",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("IRR %")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm.irr_perc,
                                                  expression:
                                                    "investorForm.irr_perc",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "irr",
                                                placeholder:
                                                  _vm.trans("transcript.irr"),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm.irr_perc,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "irr_perc",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Equity Multiple / MOIC (x)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.investorForm.moic,
                                                  expression:
                                                    "investorForm.moic",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "moic",
                                                placeholder:
                                                  _vm.trans("transcript.moic"),
                                              },
                                              domProps: {
                                                value: _vm.investorForm.moic,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "moic",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Fund Status")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.investorForm
                                                        .fund_status,
                                                    expression:
                                                      "investorForm.fund_status",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { name: "fund_status" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.investorForm,
                                                      "fund_status",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("Not available")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "Closed Ended",
                                                    },
                                                  },
                                                  [_vm._v("Closed Ended")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "Open Ended",
                                                    },
                                                  },
                                                  [_vm._v("Open Ended")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Assets Under Management (AUM) (USD MN)"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm
                                                      .assets_under_management,
                                                  expression:
                                                    "investorForm.assets_under_management",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "assets_amount",
                                                placeholder: _vm.trans(
                                                  "transcript.assets_amount"
                                                ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.investorForm
                                                    .assets_under_management,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "assets_under_management",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("HQ City")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.investorForm.hq_city,
                                                  expression:
                                                    "investorForm.hq_city",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: "hq_city",
                                                placeholder:
                                                  _vm.trans(
                                                    "transcript.hq_city"
                                                  ),
                                              },
                                              domProps: {
                                                value: _vm.investorForm.hq_city,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.investorForm,
                                                    "hq_city",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("HQ Country")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "hq_country",
                                                id: "hq_country",
                                                options: _vm.countries,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_hq_countries,
                                              },
                                              on: {
                                                select: _vm.onHQCountrySelect,
                                                remove: _vm.onHQCountryRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_hq_countries,
                                                callback: function ($$v) {
                                                  _vm.selected_hq_countries =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_hq_countries",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            staticStyle: {
                                              "margin-bottom": "52px",
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("HQ Global Sub Region")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "hq_global_sub_region",
                                                id: "hq_global_sub_region",
                                                options: _vm.regions,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_hq_global_sub_regions,
                                              },
                                              on: {
                                                select:
                                                  _vm.onHQGlobalSubRegionSelect,
                                                remove:
                                                  _vm.onHQGlobalSubRegionRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_hq_global_sub_regions,
                                                callback: function ($$v) {
                                                  _vm.selected_hq_global_sub_regions =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_hq_global_sub_regions",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-sm-6" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("HQ Global Region")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                label: "name",
                                                "track-by": "name",
                                                name: "hq_global_region",
                                                id: "hq_global_region",
                                                options: _vm.continents,
                                                placeholder: "Please choose",
                                                multiple: true,
                                                "close-on-select": true,
                                                "clear-on-select": false,
                                                "hide-selected": true,
                                                placeholder: "Please choose",
                                                selectLabel: "choose",
                                                selected:
                                                  _vm.selected_hq_global_regions,
                                              },
                                              on: {
                                                select:
                                                  _vm.onHQGlobalRegionSelect,
                                                remove:
                                                  _vm.onHQGlobalRegionRemove,
                                              },
                                              model: {
                                                value:
                                                  _vm.selected_hq_global_regions,
                                                callback: function ($$v) {
                                                  _vm.selected_hq_global_regions =
                                                    $$v
                                                },
                                                expression:
                                                  "selected_hq_global_regions",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-info pull-right",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.trans("general.save")))]
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }